import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/BIB.png";

export const bashInBerlinDetail = {
  "bash-in-berlin": {
    id: "bash-in-berlin",
    title: "Bash in Berlin",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "bash-in-berlin",
        items: [
          {
            id: "bash-in-berlin-1",
            title: "Bash in Berlin",
            description: "Berlin, Germany 2024",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
